<template>
  <div>
    <div
      class="notications xatoliklar alert-danger"
      style="z-index: 5"
      v-if="$store.state.project_date != ''"
    >
      <button
        type="button"
        aria-hidden="true"
        class="close"
        @click="$store.state.project_date = ''"
      >
        ×
      </button>
      <p><i class="fas fa-exclamation-triangle"></i>&nbsp; Хатолик</p>
      <div>{{ $store.state.project_date }}</div>
    </div>
    <!-- <RealTime/> -->
    <router-view></router-view>
  </div>
</template>

<script>
// import RealTime from "./components/RealTime.vue"
export default {
  components: {
    // RealTime
  },
  provide() {
    return {
      // local
      // BASE_URL: "http://localhost:5005/api/v1/admin-app/"

      /// doctor o
      BASE_URL: "https://api-utkir-med.digident.uz/api/v1/admin-app/"
    };
  }
};
</script>
<style>
* {
  box-sizing: border-box;
}
</style>
